import React from 'react';

export type AbStepState = 'pending' | 'active' | 'done';

interface IAbStepProps {
    num: number;
    title: string;
    state: AbStepState;
    className?: string;
    id?: string;
    onEdit?: () => void;
    editLabel?: string;
    children?: React.ReactNode;
}

export const AbStep = ({num, title, state, className, id, onEdit, editLabel, children}: IAbStepProps) => (
    <section
        id={id}
        className={`ab-step is-${state}${className ? ` ${className}` : ''}`}
        aria-label={title}
    >
        <div className="ab-step-header">
            <span
                className="ab-step-num"
                aria-hidden={true}
            >
                {state === 'done' ? <i className="fas fa-check" /> : num}
            </span>
            <h2 className="ab-step-title">{title}</h2>
            {state === 'done' && onEdit && (
                <button
                    type="button"
                    className="ab-step-edit"
                    onClick={onEdit}
                    aria-label={editLabel ?? `Edit ${title}`}
                >
                    <i
                        className="far fa-pen"
                        aria-hidden={true}
                    />
                    <span className="ab-step-edit-label">Edit</span>
                </button>
            )}
        </div>
        {children}
    </section>
);

export default AbStep;
